module.exports = __webpack_public_path__ + "img/services-icon6.8f72924c.png";